module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_4",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "307.968px",
      "height": "50.507px",
      "viewBox": "0 0 307.968 50.507",
      "enable-background": "new 0 0 307.968 50.507",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M26.485,49.819c-12.681,0-22.956-10.32-21.209-23.238C7.029,13.616,20.051,3.185,32.791,3.185\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162C16.675,32.03,19.885,38.69,29.527,38.69\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC39.588,47.698,36.033,49.819,26.485,49.819z M38.08,38.194c-1.49,0.623-4.831,1.82-8.732,1.82c-10.39,0-14.085-7.33-13.246-13.539\n  \t\tc0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498c-0.955-0.488-4.218-1.803-11.617-1.803\n  \t\tc-12.062,0-24.367,9.919-26.01,22.072C4.966,38.677,14.65,48.494,26.665,48.494c7.366,0,10.964-1.29,12.104-1.803L38.08,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M73.626,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n  \t\tc-12.683,0-21.26-10.704-19.551-23.344C49.479,13.834,60.946,3.185,73.626,3.185z M67.5,48.494\n  \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n  \t\tC47.479,38.425,55.595,48.494,67.5,48.494z M72.251,13.359c7.171,0,11.935,5.99,10.972,13.116\n  \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C58.644,19.346,65.082,13.359,72.251,13.359z\n  \t\t M68.876,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n  \t\tC58.134,32.915,62.482,38.319,68.876,38.319z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M101.919,4.642c0,0,0.25-1.348,1.153-0.511l23.343,21.636l2.956-21.128c0.053-0.378,0.426-0.659,0.752-0.659h9.962\n  \t\tc0.401,0,0.611,0.378,0.573,0.662l-5.911,43.721c0,0-0.246,1.346-1.151,0.512L110.145,27.29l-2.849,21.072\n  \t\tc-0.054,0.4-0.467,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L101.919,4.642z M106.061,47.699l2.948-21.807\n  \t\tc0.178-1.316,1.151-0.513,1.151-0.513l23.45,21.584l5.633-41.66h-8.641l-3.059,21.863c-0.184,1.316-1.152,0.509-1.152,0.509\n  \t\tl-23.337-21.63l-5.632,41.653H106.061z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M146.014,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L146.014,4.642z M155.971,12.724\n  \t\tc0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42H147.25\n  \t\tl-1.003,7.42H155.971z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M221.782,48.113c0,0,0.338,0.911-0.737,0.911H210.34c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314h-15.718l-4.144,8.309\n  \t\tc-0.129,0.258-0.406,0.436-0.682,0.436H176.53c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221\n  \t\tc0.274,0,0.496,0.184,0.558,0.414L221.782,48.113z M200.483,5.304L177.69,47.699h9.26l4.144-8.308\n  \t\tc0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L208.81,5.304H200.483z M206.027,31.536\n  \t\th-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719\n  \t\tC207.021,31.623,206.027,31.536,206.027,31.536z M202.614,19.989l-5.301,10.223h7.923L202.614,19.989z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M250.037,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC263.14,47.698,259.584,49.819,250.037,49.819z M261.631,38.194c-1.49,0.623-4.831,1.82-8.732,1.82\n  \t\tc-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498\n  \t\tc-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913\n  \t\tc7.366,0,10.964-1.29,12.104-1.803L261.631,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M273.796,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L273.796,4.642z M283.753,12.724\n  \t\tc0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n  \t\tl-1.003,7.42H283.753z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "inny",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "name",
      "value": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "inny",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "email",
      "name": "email",
      "value": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "message",
      "rows": "8",
      "required": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "Send it"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "response"
  }, [_c('p', [_vm._v("Thanks! I'll get back to you soon :)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a5b4674"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Contact.vue
// module id = 46
// module chunks = 0